/**
 * Why a blueprint gets no copy, for a copy_coverage `reason` (branddetails
 * frame_copy skip codes). Null means the row exists but its cells are empty.
 */
export function copyGapCause(
  reason: string | null | undefined,
  slug: string,
): string {
  switch (reason ?? null) {
    case null:
      return `D20's row for slug "${slug}" leaves these blank`;
    case "frame_no_slug":
      return "This blueprint has no slug, so no D20 row can match it";
    case "template_tile_unmatched":
      return `D20's row for slug "${slug}" is ignored: its tileName is blank or not on the tiles tab`;
    case "template_duplicate":
      return `D20's row for slug "${slug}" is ignored: an earlier row has the same tileName and frameName`;
    case "template_no_copy_columns":
      return `D20's row for slug "${slug}" is ignored: it has no copy columns`;
    case "no_template_row":
      return `D20 has no row for slug "${slug}"`;
    default:
      return `D20 has no usable row for slug "${slug}" (${reason})`;
  }
}
